export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const INDUSTRY_JOB_ROLES = {
  "Technology": [
    "Software Developer", "Data Analyst", "Cybersecurity Analyst", "IT Support Technician",
    "Network Engineer", "UX / UI Designer", "Product Manager", "DevOps Engineer",
    "Project Manager", "Business Analyst",
  ],
  "Healthcare": [
    "Nurse", "Paramedic", "Physiotherapist", "Care Worker", "Healthcare Assistant",
    "Occupational Therapist", "Radiographer", "Pharmacy Technician", "Administrator",
  ],
  "Finance": [
    "Accountant", "Financial Advisor", "Financial Analyst", "Bookkeeper",
    "Tax Consultant", "Insurance Broker", "Mortgage Advisor", "Business Analyst",
  ],
  "Education": [
    "Teacher", "Teaching Assistant", "Learning Support Assistant",
    "Nursery Practitioner", "School Administrator", "Lecturer", "Researcher",
  ],
  "Engineering": [
    "Civil Engineer", "Mechanical Engineer", "Structural Engineer",
    "Quantity Surveyor", "Site Manager", "CAD Technician", "Project Manager",
  ],
  "Construction": [
    "Bricklayer", "Carpenter", "Joiner", "Painter & Decorator",
    "Roofer", "Scaffolder", "General Labourer", "Site Supervisor",
    "Quantity Surveyor", "Site Manager",
  ],
  "Plumbing & Heating": [
    "Plumber", "Gas Engineer", "Heating Engineer", "Boiler Technician",
  ],
  "Electrical": [
    "Electrician", "Electrical Engineer", "Solar Panel Installer", "Alarm Technician",
  ],
  "Motor Trade": [
    "Vehicle Technician", "MOT Tester", "Auto Electrician",
    "Body Shop Technician", "Parts Advisor",
  ],
  "Hospitality": [
    "Chef", "Sous Chef", "Kitchen Assistant", "Front of House Manager",
    "Waiter / Waitress", "Hotel Receptionist", "Event Coordinator",
    "Customer Service Representative",
  ],
  "Retail": [
    "Retail Assistant", "Store Manager", "Visual Merchandiser",
    "Buyer", "Customer Service Representative", "Sales Executive",
  ],
  "Manufacturing": [
    "Production Operative", "Quality Controller", "Warehouse Operative",
    "Logistics Coordinator", "Fork Lift Operator",
  ],
  "Media & Marketing": [
    "Marketing Assistant", "Marketing Manager", "Social Media Manager",
    "Graphic Designer", "Copywriter", "Journalist", "PR Executive",
    "Content Creator", "Video Editor", "Photographer",
  ],
  "Legal": [
    "Lawyer", "Paralegal", "Legal Secretary", "Compliance Officer", "Administrator",
  ],
  "Sports & Fitness": [
    "Personal Trainer", "Sports Coach", "PE Teacher",
    "Physiotherapist", "Sports Development Officer",
  ],
  "Government & Public Sector": [
    "Administrator", "Policy Officer", "Social Worker", "Housing Officer",
    "Project Manager",
  ],
  "Non-Profit & Charity": [
    "Fundraiser", "Community Development Worker", "Volunteer Coordinator",
    "Administrator", "Social Worker",
  ],
  "Energy & Utilities": [
    "Energy Analyst", "Wind Turbine Technician", "Water Treatment Operative",
    "Electrician", "Engineer",
  ],
  "Agriculture": [
    "Farm Worker", "Horticulturalist", "Agricultural Technician",
  ],
  "Transport & Logistics": [
    "HGV Driver", "Delivery Driver", "Fleet Manager", "Logistics Coordinator",
    "Logistics Planner",
  ],
  "Telecommunications": [
    "Network Technician", "Field Engineer", "Broadband Installer",
    "Customer Service Representative",
  ],
  "Real Estate & Property": [
    "Estate Agent", "Property Manager", "Surveyor", "Letting Agent",
    "Administrator",
  ],
  "Creative & Design": [
    "Graphic Designer", "Architect", "Interior Designer", "Fashion Designer",
    "Illustrator", "UX / UI Designer", "Content Creator",
  ],
  "Science & Research": [
    "Research Scientist", "Lab Technician", "Clinical Researcher",
    "Data Analyst", "Researcher",
  ],
  "Social Care": [
    "Support Worker", "Mental Health Worker", "Family Support Worker",
    "Care Worker", "Social Worker", "Administrator",
  ],
  "Armed Forces": [
    "Army Officer", "Navy Rating", "RAF Technician",
  ],
  "Hair & Beauty": [
    "Hairdresser", "Barber", "Beauty Therapist", "Nail Technician",
  ],
  "Childcare & Early Years": [
    "Childminder", "Nursery Nurse", "Nursery Practitioner",
    "Play Worker", "Teaching Assistant",
  ],
};

export const JOB_ROLES = [
  "Accountant", "Administrator", "Agricultural Technician", "Alarm Technician",
  "Architect", "Army Officer", "Auto Electrician", "Barber",
  "Beauty Therapist", "Body Shop Technician", "Boiler Technician", "Bookkeeper",
  "Bricklayer", "Business Analyst", "Business Development Manager", "Buyer",
  "CAD Technician", "Care Worker", "Carpenter", "Chef",
  "Childminder", "Civil Engineer", "Clinical Researcher", "Compliance Officer",
  "Community Development Worker", "Content Creator", "Copywriter", "Customer Service Representative",
  "Cybersecurity Analyst", "Data Analyst", "Delivery Driver", "DevOps Engineer",
  "Electrical Engineer", "Electrician", "Energy Analyst", "Estate Agent",
  "Event Coordinator", "Family Support Worker", "Farm Worker", "Fashion Designer",
  "Financial Advisor", "Financial Analyst", "Fleet Manager", "Fork Lift Operator",
  "Front of House Manager", "Fundraiser", "Gas Engineer", "General Labourer",
  "Graphic Designer", "Hairdresser", "Healthcare Assistant", "Heating Engineer",
  "HGV Driver", "Horticulturalist", "Hotel Receptionist", "Housing Officer",
  "HR Assistant", "HR Manager", "Illustrator", "Insurance Broker",
  "Interior Designer", "IT Support Technician", "Joiner", "Journalist",
  "Kitchen Assistant", "Lab Technician", "Lawyer", "Learning Support Assistant",
  "Lecturer", "Legal Secretary", "Letting Agent", "Logistics Coordinator",
  "Marketing Assistant", "Marketing Manager", "Mechanical Engineer", "Mental Health Worker",
  "MOT Tester", "Mortgage Advisor", "Nail Technician", "Network Engineer",
  "Network Technician", "Nurse", "Nursery Nurse", "Nursery Practitioner",
  "Occupational Therapist", "Painter & Decorator", "Paralegal", "Paramedic",
  "Parts Advisor", "PE Teacher", "Personal Trainer", "Pharmacy Technician",
  "Photographer", "Play Worker", "Plumber", "Policy Officer",
  "PR Executive", "Production Operative", "Product Manager", "Project Manager",
  "Property Manager", "Quality Controller", "Quantity Surveyor", "Radiographer",
  "RAF Technician", "Research Scientist", "Researcher", "Retail Assistant",
  "Roofer", "Sales Executive", "Scaffolder", "School Administrator",
  "Site Manager", "Site Supervisor", "Social Media Manager", "Social Worker",
  "Software Developer", "Solar Panel Installer", "Sous Chef", "Sports Coach",
  "Sports Development Officer", "Store Manager", "Structural Engineer", "Support Worker",
  "Surveyor", "Tax Consultant", "Teacher", "Teaching Assistant",
  "UX / UI Designer", "Vehicle Technician", "Video Editor", "Visual Merchandiser",
  "Volunteer Coordinator", "Waiter / Waitress", "Warehouse Operative",
  "Wind Turbine Technician",
];

export const INDUSTRIES = [
  "Agriculture", "Armed Forces", "Childcare & Early Years", "Construction",
  "Creative & Design", "Education", "Electrical", "Energy & Utilities",
  "Engineering", "Finance", "Government & Public Sector", "Hair & Beauty",
  "Healthcare", "Hospitality", "Legal", "Manufacturing",
  "Media & Marketing", "Motor Trade", "Non-Profit & Charity", "Plumbing & Heating",
  "Real Estate & Property", "Retail", "Science & Research", "Social Care",
  "Sports & Fitness", "Technology", "Telecommunications", "Transport & Logistics",
];

export const SALARY_BRACKETS = [
  "Under 15k", "15k-20k", "20k-25k", "25k-30k",
  "30k-40k", "40k-50k", "50k-60k", "60k+",
];

export const EXPERIENCE_LEVELS = [
  "Under 1 Year", "1-3 Years", "3-5 Years", "5-10 Years", "10-15 Years", "15+ Years",
];

export const UK_REGIONS = [
  "London", "South East", "South West", "East Midlands",
  "West Midlands", "North West", "North East", "Yorkshire",
  "Scotland", "Wales", "Northern Ireland", "East of England",
  "Remote/Anywhere",
];

export const DRIVING_LICENCE_OPTIONS = ["Yes - Full", "Yes - Provisional", "No"];

export const RELOCATE_OPTIONS = ["Yes", "No"];

export const JOB_TYPES = ["Full-time", "Part-time"];

export const CONTRACT_TYPES = [
  "Permanent", "Fixed-term", "Contract / Freelance", "Internship", "Apprenticeship",
];

export const LOCATION_TYPES = ["On-site", "Hybrid", "Remote"];

export const JOB_STATUSES = ["active", "draft", "closed"];

export const TRANSFERABLE_SKILLS = [
  "Communication", "Teamwork", "Problem Solving", "Leadership",
  "Time Management", "Adaptability", "Critical Thinking", "Creativity",
  "Attention to Detail", "Customer Service", "Organisation", "Initiative",
  "Resilience", "Negotiation", "Presentation Skills", "Project Management",
  "Data Analysis", "Conflict Resolution", "Mentoring", "Research",
  "IT Literacy", "Commercial Awareness", "Networking", "Report Writing",
  "Decision Making", "Emotional Intelligence", "Analytical Thinking", "Strategic Planning",
];

export const QUALIFICATION_LEVELS = [
  "No formal qualifications",
  "Entry Level / Functional Skills",
  "GCSE (grades 1–3) / BTEC Level 1",
  "GCSE (grades 4–9) / BTEC First",
  "BTEC National / NVQ Level 3",
  "A-Level / T-Level / Access to HE",
  "HNC / HND / Foundation Degree",
  "Bachelor's Degree",
  "Master's / PGCE / MBA",
  "PhD / Doctorate",
];

export const WORK_EXPERIENCE_TYPES = [
  "Full-Time Permanent",
  "Apprenticeship (Level 1-2)",
  "Apprenticeship (Level 3-5)",
  "Apprenticeship (Level 6-7)",
  "Short-term Work Experience (1-2 weeks)",
  "Volunteer Work Experience",
];
